import React, { useState } from 'react'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import posthog from 'posthog-js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { useHistory } from 'react-router-dom'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'
import { SaveForLaterModal } from './save-for-later-modal'

export const SaveForLaterBanner = injectSheet({
  banner: {
    width: '100%',
    maxWidth: '720px',
    marginTop: '8px',
    background: '#fff',
    color: 'var(--gray)',
    borderTop: '8px solid #00aeef',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '16px',
    padding: '20px',
    boxSizing: 'border-box',
    textAlign: 'center',
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '24px',
      padding: '20px 24px',
      textAlign: 'left'
    }
  },
  text: {
    margin: 0,
    font: 'var(--body)',
    lineHeight: 1.4,
    color: 'var(--gray)',
    '@media (min-width: 768px)': {
      flex: 1,
      minWidth: 0
    }
  },
  cta: {
    flexShrink: 0,
    width: '100%',
    justifyContent: 'center',
    background: 'var(--yellow) !important',
    color: 'var(--gray) !important',
    border: '1px solid var(--gray) !important',
    '&:hover': {
      background: 'var(--yellow-) !important'
    },
    '@media (min-width: 768px)': {
      width: 'auto'
    }
  },
  savedContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
    minWidth: 0,
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      alignItems: 'flex-start',
      textAlign: 'left'
    }
  },
  tick: {
    flexShrink: 0,
    color: 'var(--blue)',
    fontSize: '28px',
    lineHeight: 1,
    '@media (min-width: 768px)': {
      marginTop: '2px'
    }
  },
  savedText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: 0
  },
  savedHeading: {
    margin: 0,
    font: 'var(--body)',
    fontWeight: 'bold',
    lineHeight: 1.4,
    color: 'var(--gray)'
  },
  savedSubtext: {
    margin: 0,
    font: 'var(--body)',
    fontWeight: 'normal',
    lineHeight: 1.4,
    color: 'var(--gray)'
  },
  myLessonsCta: {
    flexShrink: 0,
    width: '100%',
    justifyContent: 'center',
    '@media (min-width: 768px)': {
      width: 'auto'
    }
  }
})(function SaveForLaterBanner({ classes, presentation }) {
  const history = useHistory()
  const {
    freeTrial,
    validPaymentMethod,
    hasAccessToTL
  } = useSubscriptionDetails()
  const [modalOpen, setModalOpen] = useState(false)
  const [savedState, setSavedState] = useState(null)

  if (savedState) {
    return (
      <div className={classes.banner}>
        <div className={classes.savedContent}>
          <FontAwesomeIcon
            icon={faCheckCircle}
            className={classes.tick}
            aria-hidden
          />
          <div className={classes.savedText}>
            <p className={classes.savedHeading}>Lesson ready!</p>
            <p className={classes.savedSubtext}>
              {savedState.withDate
                ? "You can find this lesson anytime in My Lessons. We've also emailed you a copy."
                : 'You can find this lesson anytime in My Lessons.'}
            </p>
          </div>
        </div>
        <Button
          tall
          className={`${classes.myLessonsCta} metrics__prompt_go_to_my_lessons`}
          onClick={() => history.push('/')}>
          Go to My Lessons
        </Button>
      </div>
    )
  }

  return (
    <>
      <div className={classes.banner}>
        <p className={classes.text}>
          <strong>Planning for next week?</strong>
          <br />
          <small>
            Save this lesson and we'll email you a copy so it's ready when you
            need it.
          </small>
        </p>
        <Button
          tall
          className={`${classes.cta} metrics__prompt_save_for_later`}
          onClick={() => {
            posthog.capture('clicked on save for later banner from prompt', {
              lesson_category: presentation?.category || null,
              lesson_id: presentation?.id || null,
              lesson_title: presentation?.title || null,
              freeTrial,
              validPaymentMethod,
              hasAccessToTL
            })
            setModalOpen(true)
          }}>
          Save for later
        </Button>
      </div>
      <SaveForLaterModal
        isOpen={modalOpen}
        requestClose={() => setModalOpen(false)}
        presentation={presentation}
        onSaved={({ withDate }) => setSavedState({ withDate })}
        location="save-for-later-banner"
      />
    </>
  )
})
